import NotificationIntubationDateInput from '../../../../../components/HookFormComponents/Inputs/NotificationIntubationDate';
import NotificationMoreInfoInput from '../../../../../components/HookFormComponents/Inputs/NotificationMoreInfo';
import UnitInput from '../../../../../components/HookFormComponents/Inputs/UnitInput';
import { EpStepContent } from '../../../../../components/HookFormComponents/components/EpStepContent';
import { useTranslation as t } from '../../../../../hooks/useTranslation';
import { globalizationService } from '../../../../../services/globalizationService';
import styles from './steps.module.scss';

export default function Step2IncidentNotification() {
  const tag = 'PSNotificationWhen';
  const { translations } = globalizationService.getTranslationsByTag(tag);

  return (
    <div className={styles['steps']}>
      <EpStepContent.Card title={t(translations, 'When did it occur?')}>
        <NotificationIntubationDateInput translations={translations} />
        <NotificationMoreInfoInput origem="incident" translations={translations} />
      </EpStepContent.Card>
      <EpStepContent.Card title={t(translations, 'Where did it occur?')}>
        <UnitInput translations={translations} />
      </EpStepContent.Card>
    </div>
  );
}
